import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {必須入力, 日付書式} from '@/type/validation/validator';
import {入札開始依頼型} from '@/type/estimates/comparison';

export default class 入札開始依頼チェッカー {
  単項目チェック結果: Error[];

  constructor(target: 入札開始依頼型) {
    const 単項目チェック = new ValidationResult(単項目チェックvalidators);
    単項目チェック.validate(target);
    this.単項目チェック結果 = 単項目チェック.getErrors;
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0;
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === 0));
  }

  errorMessages(): string[] {
    return this.単項目チェック結果.map((value) => `${value.message}`);
  }
}

const 単項目チェックvalidators: Validator[] = [
  {
    name: '適用開始日',
    constraints: [
      {method: 必須入力, message: '適用開始日は必須です'},
      {method: 日付書式, message: '適用開始日の書式が不正です'},
    ],
  },
];
